import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_CreateEntityForm.scss';

/**
 * A template for create entity form.
 *
 * @param className
 * @param children
 * @returns {*}
 */
const CreateEntityForm = ({ className, children }) => {
  const classes = classNames('CreateEntityForm', className);
  return <div className={classes}>{children}</div>;
};

CreateEntityForm.propTypes = {
  /**
   * Custom className for the component
   */
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * A template for create entity form content.
 * @param className
 * @param children
 * @returns {*}
 */
const CreateEntityFormContent = ({ className, children }) => {
  const classes = classNames('CreateEntityForm__content', className);
  return <div className={classes}>{children}</div>;
};

CreateEntityFormContent.propTypes = {
  /**
   * Custom className for the component
   */
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * A template for create entity form footer.
 * @param className
 * @param children
 * @returns {*}
 */
const CreateEntityFormFooter = ({ className, children }) => {
  const classes = classNames('CreateEntityForm__footer', className);
  return <div className={classes}>{children}</div>;
};

CreateEntityFormFooter.propTypes = {
  /**
   * Custom className for the component
   */
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

CreateEntityForm.Content = CreateEntityFormContent;
CreateEntityForm.Footer = CreateEntityFormFooter;

export default CreateEntityForm;
